import { render, staticRenderFns } from "./product.vue?vue&type=template&id=4ce970e2&scoped=true&"
import script from "./product.vue?vue&type=script&lang=js&"
export * from "./product.vue?vue&type=script&lang=js&"
import style0 from "./product.vue?vue&type=style&index=0&id=4ce970e2&lang=scss&scoped=true&"
import style1 from "./product.vue?vue&type=style&index=1&id=4ce970e2&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce970e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/dvl/tthomsen/compiere-all/pharmanord2011/template/webapps/integrationtest/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ce970e2')) {
      api.createRecord('4ce970e2', component.options)
    } else {
      api.reload('4ce970e2', component.options)
    }
    module.hot.accept("./product.vue?vue&type=template&id=4ce970e2&scoped=true&", function () {
      api.rerender('4ce970e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/product.vue"
export default component.exports